// Stratégie d'ouverture des liens (2026-07-17) : nouvel onglet UNIQUEMENT pour
// les destinations qui font SORTIR du parcours — site externe (autre domaine) ou
// autre application Shopify (/apps/…, ex. l'espace ambassadeur·rice). Toute la
// navigation interne (produits, séjours, collections, pages) reste en LIEN DIRECT
// (même onglet), pour préserver le bouton « retour ». Aucun changement visuel.
// Idempotent : ne retire jamais rien, n'ajoute que ce qui manque.
(function () {
  function run() {
    var host = location.host;
    document.querySelectorAll("a[href]").forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (!href || href.charAt(0) === "#" || /^(mailto:|tel:|javascript:)/i.test(href)) return;
      var externe = false, appli = false;
      try {
        var u = new URL(href, location.origin);
        externe = !!u.host && u.host !== host;
        appli = /^\/apps\//.test(u.pathname);
      } catch { return; }
      if (!(externe || appli)) return; // interne → on laisse en lien direct
      if (!a.getAttribute("target")) a.setAttribute("target", "_blank");
      if (a.getAttribute("target") === "_blank") {
        var rel = a.getAttribute("rel") || "";
        if (rel.indexOf("noopener") === -1) a.setAttribute("rel", (rel + " noopener").trim());
        if (!a.getAttribute("aria-label")) {
          var t = (a.textContent || "").replace(/\s+/g, " ").trim();
          if (t) a.setAttribute("aria-label", t + " (nouvel onglet)");
        }
      }
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
